<template>
  <zm-alert type="warning" show-icon :closable="false" class="max-phone-number__alert">
    <p>{{ $t('billing.pbx.max_phone_number_desc', [maxSelectPhoneNumbers]) }}</p>
  </zm-alert>
</template>

<script>
import { maxSelectPhoneNumbers } from '@/plans/ZOOM_PHONE/helper/constants';

export default {
  name: 'MaxPhoneNumberWarning',
  props: {
    maxSelectPhoneNumbers: {
      type: Number,
      default: maxSelectPhoneNumbers,
    }
  }
};
</script>

<style lang="scss">
.max-phone-number {
  &__alert {
    &.zm-alert {
      &--warning {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        border-radius: 8px;
        background: #F7F7F8;

        .zm-alert__icon {
          font-size: 14px;
          color: #9191A4;
        }
      }
    }

    p {
      font-size: 14px;
      text-align: left;
    }
  }
}
</style>
